<p-table #mdmCrudTable [columns]="tableCols" [value]="masterLists" selectionMode="single" [(selection)]="selectedMasterList" (onRowSelect)="onRowSelect($event)">
    <ng-template pTemplate="caption">
        <div class="d-flex flex-row justify-content-between">
            <div >
                <button type="button" pButton icon="pi pi-plus" (click)="showDialogToAddMasterList()" label="Add" style="height: 32px;"></button>
            </div>
            <div >
                {{title}}
            </div>
            <div >
                <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                <input type="text" pInputText size="50" placeholder="Search" (input)="mdmCrudTable.filterGlobal($event.target.value, 'contains')" style="width:auto; height: 32px;">
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngFor="let col of columns" scope="col" [ngStyle]="{'width': col.width ,'display': col.display}" 
                [pSortableColumn]="col.field==isBA || col.field==isLab || col.field == isSalesItemType? col.sort:col.field">
                {{col.header}}
                <p-sortIcon
                    [field]="col.field==isBA || col.field==isLab || col.field == isSalesItemType? col.sort:col.field">
                </p-sortIcon>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
            <ng-container *ngFor="let col of columns">

                <td *ngIf="col.field!=isActive && col.field!=isNgs && col.field!=isArray && col.field != isDefault && col.field != isAllowExcelUpload && col.field != isPremixed && 
                    col.field!='printEnabled' && col.field!='defaultPrinter' && col.field!=isBA && col.field!=isLab && 
                    masterListType != machineType && col.field!=isSalesItemType && col.field!==isTagSystem && col.field != isProcessStepMachineType && 
                    col.field != isProcessStepPrinter && col.field != isProductType && col.field != isBuffer && col.field != isWorkflow &&
                    col.field!=isDefaultTemplate &&  col.field != plateIDRegex &&  col.field !=beadchipIDRegex && col.field != poolIDRegex && 
                    col.field!=isReception && col.field!=isLiquidHandling && col.field!=isMeasurements && col.field!=isSequencer && col.field!=isScanner && col.field!=isqubit && col.field!=isqPcr &&
                    col.field!=newUI && col.field!=updateWeatherbys && col.field!=activationCheck &&
                    col.field!=automatedReception && col.field!=qcScan && col.field!=plateMerge && col.field!=samplesHaveBarcodes &&
                    col.field!=identifiers && col.field!=tat && col.field!=upstream && col.field!=downstream && col.field != isDateRange" class="wrapword">
                    {{rowData[col.field]}}
                </td>
                <td *ngIf="masterListType == machineType && col.field!=isMachineType && col.field!=isLab && col.field!=isActive">
                    {{rowData[col.field]}}
                </td>
                <td *ngIf="col.field==isMachineType && masterListType == machineType">
                    {{rowData[col.field]!= null? rowData[col.field].name :''}} 
                </td>
                <td *ngIf="col.field == isActive || col.field == isNgs || col.field == isArray || col.field== isDefault || col.field ==isAllowExcelUpload || col.field == isPremixed || 
                    col.field==isReception || col.field==isLiquidHandling || col.field==isMeasurements || col.field==isSequencer || col.field==isScanner || col.field==isqubit || col.field==isqPcr ||
                    col.field==newUI || col.field==updateWeatherbys || col.field==activationCheck ||
                    col.field==automatedReception || col.field==qcScan || col.field==plateMerge || col.field==samplesHaveBarcodes || col.field == isDateRange">
                    <p-checkbox id="active" disabled="true" [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
                </td>
                <td *ngIf="col.field == 'printEnabled'">
                    <p-checkbox id="printEnabled" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
                </td>
                <td *ngIf="col.field == 'defaultPrinter'">
                    <p-checkbox id="defaultPrinter" disabled [(ngModel)]="rowData[col.field]" binary="true">
                    </p-checkbox>
                </td>
                <td
                    *ngIf="col.field == isBA || col.field==isLab || col.field == isProcessStepMachineType || col.field == isProcessStepPrinter || col.field == isProductType || col.field == isBuffer ">
                    {{rowData[col.field]!= null? rowData[col.field].name :''}} 
                </td>
                <td *ngIf="col.field==isSalesItemType">
                    <div *ngFor="let sit of rowData[col.field]">
                        {{sit.sitKey}} 
                    </div>
                </td>
                <td *ngIf="col.field==isTagSystem">
                    {{rowData[col.field]!= null? rowData[col.field].tagSystemName: ''}} 
                </td>
                <td *ngIf="col.field==isWorkflow">
                    {{rowData[col.field]!= null? rowData[col.field].workFlowName :''}} 
                </td>
                <td *ngIf="col.field == isDefaultTemplate">
                    {{rowData[col.field]!= null? rowData[col.field].templateName :''}} 
                </td>
                <td *ngIf="col.field==identifiers || col.field==tat || col.field==upstream || col.field==downstream">
                    {{ getValuesFromLists(rowData[col.field]) }}
                </td>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="summary" let-rowData>
        <div style="text-align:left">
            <button type="button" pButton icon="pi pi-plus" (click)="showDialogToAddMasterList()" label="Add" style="height:32px;"></button>
        </div>
    </ng-template>
</p-table>

<p-dialog header="{{popupTitle}} Details" [(visible)]="displayMasterListDialog" [style]="{width:'800px'}" appendTo="body"
    showEffect="fade" [modal]="true" position="top" baseZIndex="10" (onHide)="onDialogEvent.emit('close')">
    <div *ngIf="masterList">
        <div *ngFor="let col of tableCols">
            <div class="form-group m-2">
                <div *ngIf="col.field!=isDefaultLanguage">
                    <label>{{col.header}}</label>
                </div>

                <div
                    *ngIf="col.field!=isActive && col.field!=isNgs && col.field!=isArray  && col.field != isDefault  && col.field != isAllowExcelUpload && col.field != isPremixed && col.field != 'printEnabled' && col.field != 'defaultPrinter' && col.field!=isLab && col.field!=isBA
                && col.field!=isDefaultLanguage && col.field != isCountry && col.field != isProductType && masterListType != seqConfigType && col.field != isHazardousType
                && col.field != isOriginalVolume && col.field != isRemainingVolume &&masterListType != machineType  && col.field != isWorkflow
                && col.field != isBmsKitProductName && col.field != isBmsTubeProductName && col.field != isProcessStepPrinter && col.field !=isProcessStepMachineType && masterListType != processStep 
                && masterListType != echoConfigType && col.field != isCategory && col.field !=isJobTime && col.field != isBuffer && 
                col.field != isAssayType && col.field!=isSalesItemType && col.field!=isTagSystem && col.field!=isPcrKits && col.field!=isHostAddress && col.field!= isDefaultTemplate &&
                col.field!=isMaxRedo && col.field!=isProductMaxRedo && col.field!=isReactionOptionProtocol && col.field != 'subType' &&  col.field != isFileType && col.field != isIOCapacity && col.field != isManufacturer &&
                col.field!=isReception && col.field!=isLiquidHandling && col.field!=isMeasurements && col.field!=isSequencer && col.field!=isScanner && col.field!=isqubit && col.field!=isqPcr && 
                col.field!=newUI && col.field!=updateWeatherbys && col.field!=activationCheck &&
                col.field!=automatedReception && col.field!=qcScan && col.field!=plateMerge && col.field!=samplesHaveBarcodes && col.field != isDateRange">

                    <input pInputText class="form-control" [ngClass]=" { 'disableTextBox' : isLabValid(col.field) }"
                        [(ngModel)]="masterList[col.field]" [pattern]="col.pattern"
                        (change)="masterList[col.field]=masterList[col.field].trim()">
                </div>

                <div
                    *ngIf="col.field!=isActive && col.field!=isLab && col.field != isMachineType && masterListType == machineType && col.field !=isSalesItemType 
                    && col.field!=isTagSystem && col.field != isHostAddress && col.field != 'subType' && col.field != isFileType && col.field != isIOCapacity
                    && col.field != isManufacturer && col.field!=newUI && col.field!=updateWeatherbys && col.field!=activationCheck &&
                    col.field!=automatedReception && col.field!=qcScan && col.field!=plateMerge && col.field!=samplesHaveBarcodes && col.field != isDateRange">
                    <input pInputText class="form-control" [(ngModel)]="masterList[col.field]"
                        (change)="masterList[col.field]=masterList[col.field].trim()">
                </div>
                <div
                    *ngIf="col.field == isActive || col.field == isNgs || col.field == isArray || col.field == isDefault ||col.field== isAllowExcelUpload || col.field == isPremixed ||
                    col.field == isFlaTestProcess || col.field == isAll384Controls || col.field == isUnboxingInBatches || col.field == isfasterFinderAutoRedo || col.field == haveClippingMachine || col.field == isReducedConfirmationTests || col.field == isReportingOutsideBB || col.field == isResultReportPerSender ||
                    col.field==isReception || col.field==isLiquidHandling || col.field==isMeasurements || col.field==isSequencer || col.field==isScanner || col.field==isqubit || col.field==isqPcr ||
                    col.field==newUI || col.field==updateWeatherbys || col.field==activationCheck ||
                    col.field==automatedReception || col.field==qcScan || col.field==plateMerge || col.field==samplesHaveBarcodes || col.field == isDateRange">
                    <p-checkbox id="active" [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
                </div>
                <div *ngIf="col.field == 'printEnabled'">
                    <p-checkbox id="printEnabled" [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
                </div>
                 
                <div *ngIf="col.field == 'defaultPrinter'">
                    <p-checkbox id="defaultPrinter" [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
                </div>
                 
                <div
                    *ngIf="col.field == isLab && masterListType!= product && masterListType!= printer && masterListType!= machineType">
                    <p-dropdown [options]="labOptions" [(ngModel)]="selectedLab" [filter]="true"
                        placeholder="Select a Lab" optionLabel="name" [showClear]="true"></p-dropdown>
                </div>
                 
                <div id="selectLabForProduct"
                    *ngIf="col.field == isLab && (masterListType == product || masterListType== printer || masterListType== machineType)">
                    <p-dropdown [options]="labOptions" [(ngModel)]="selectedLab" [filter]="true"
                        placeholder="Select a Lab" optionLabel="name" [showClear]="true"
                        (onChange)="onLabSelect($event.value)"></p-dropdown>
                </div>
                 
                <div *ngIf="col.field == isBA">
                    <p-dropdown [options]="baOptions" [(ngModel)]="selectedBA" [filter]="true" placeholder="Select a BA"
                        [style]="{'width':'230px'}" optionLabel="name" [showClear]="true"></p-dropdown>
                </div>
                 
                <div *ngIf="col.field == isCountry">
                    <p-dropdown [options]="countries" [(ngModel)]="selectedCountryCode" [filter]="true"
                        [style]="{'width':'230px'}" placeholder="Select a Country" [showClear]="true"></p-dropdown>
                </div>
                 
                <div *ngIf="col.field == isProductType">
                    <p-dropdown [options]="productOptions" [(ngModel)]="selectedProdType" [filter]="true"
                        [style]="{'width':'230px'}" optionLabel="name" placeholder="Select a Product Type"
                        [showClear]="true"></p-dropdown>
                </div>
                 
                <div *ngIf="col.field == isWellType">
                    <p-dropdown [options]="wellTypes" [(ngModel)]="selectedWellType" [filter]="true"
                        [style]="{'width':'230px'}" optionLabel="label" placeholder="Select a Well Type"
                        [showClear]="true"></p-dropdown>
                </div>
                 
                <div *ngIf="col.field == isCategory">
                    <p-dropdown [options]="categories" [(ngModel)]="selectedCategory" [filter]="true"
                        [style]="{'width':'350px'}" optionLabel="label" placeholder="Select a Category"
                        [showClear]="true"></p-dropdown>
                </div>
                 
                <div *ngIf="col.field == isHazardousType">
                    <p-dropdown [options]="hazardousTypeOptions" [(ngModel)]="selectedHazardoustype"
                        [style]="{'width':'350px'}" [filter]="true" placeholder="Select a Hazaradous Type"
                        optionLabel="label" [showClear]="true"></p-dropdown>
                </div>
                 
                <div *ngIf="col.field==isMachineType && masterListType==machineType">
                    <p-dropdown [options]="machineTypesOptions" [(ngModel)]="selectedMachineType" [filter]="true"
                        placeholder="Select a Machine Type" [style]="{'width':'230px'}" optionLabel="name"
                        [showClear]="true" (onChange)="col.onChangeEvent?handleMachineTypeChange($event.value):''">
                    </p-dropdown>
                </div>
                 
                <div *ngIf="col.field == isOriginalVolume || col.field == isRemainingVolume">
                    <input pInputText class="form-control" [(ngModel)]="masterList[col.field]" maxlength="14"
                        oninput="this.value = this.value.replace(/[^0-9]/, '')"
                        (change)="masterList[col.field]=masterList[col.field].trim()">
                </div>
                 
                <div
                    *ngIf="masterListType == seqConfigType && col.field != isPlateSealing && col.field != isLab && col.field != isProductType && col.field != isActive && col.field != isOriginalVolume && col.field != isRemainingVolume && col.field != isWellType">
                    <input pInputText class="form-control" [(ngModel)]="masterList[col.field]" maxlength="20"
                        oninput="this.value = this.value.replace(/[^A-Za-z0-9(){}_+-]/, '')"
                        (change)="masterList[col.field]=masterList[col.field].trim()">
                </div>
                 
                <div *ngIf="masterListType == seqConfigType && col.field == isPlateSealing">
                    <input pInputText class="form-control" [(ngModel)]="masterList[col.field]" maxlength="20"
                        (change)="masterList[col.field]=masterList[col.field].trim()">
                </div>
                 
                <div *ngIf="col.field == isJobTime">
                    <input pInputText class="form-control" [(ngModel)]="masterList[col.field]"
                        (change)="changeJobTimeForProduct()">
                </div>
                 
                <div *ngIf="col.field == isSalesItemType">
                    <p-multiSelect [options]="sitConfigOptions" [(ngModel)]="selectedSitConfigArray" [filter]="true"
                        [style]="{'width':'300px'}" optionLabel="sitKey" placeholder="Select a Sales Item Type">
                    </p-multiSelect>
                </div>
                 
                <div *ngIf="col.field == isTagSystem">
                    <p-dropdown [options]="tagSystemOptions" [(ngModel)]="selectedTagSystemType" [filter]="true"
                        [style]="{'width':'300px'}" optionLabel="tagSystemName" placeholder="Select a Tag System"
                        [showClear]="true"></p-dropdown>
                </div>
                 
                <div *ngIf="col.field == isPcrKits">
                    <p-multiSelect [options]="pcrKits" [(ngModel)]="selectedPCRConfigArray" [filter]="true"
                        [style]="{'width':'300px'}" optionLabel="pcrKey" placeholder="Select Pcr Kits">
                    </p-multiSelect>
                </div>
                 
                <div *ngIf="col.field == isBmsKitProductName">
                    <p-dropdown [options]="bmsProductNames" [(ngModel)]="selectedBmsKitProductName" [filter]="true"
                        optionLabel="name" placeholder="Select a BMS Kit Product name"
                        [showClear]="true"></p-dropdown>
                </div>
                 
                <div *ngIf="col.field == isBmsTubeProductName">
                    <p-dropdown [options]="bmsProductNames" [(ngModel)]="selectedBmsTubeProductName" [filter]="true"
                        optionLabel="name" placeholder="Select a BMS Tube Product Name"
                        [showClear]="true"></p-dropdown>
                </div>
                 
                <div *ngIf="col.field == isWorkflow">
                    <p-dropdown [options]="ngsWorkFlowOptions" [(ngModel)]="selectedNGSWorkFlowType" [filter]="true"
                        [style]="{'width':'230px'}" optionLabel="workFlowName" placeholder="Select a Workflow Type"
                        [showClear]="true"></p-dropdown>
                </div>
                 
                <div *ngIf="col.field == isProcessStepPrinter">
                    <p-dropdown [options]="printerOptions" [(ngModel)]="selectedPrinter" [filter]="true"
                        [style]="{'width':'230px'}" optionLabel="name" placeholder="Select a printer"
                        [showClear]="true"></p-dropdown>
                </div>
                 
                <div *ngIf="col.field == isProcessStepName && masterListType == processStep">
                    <p-dropdown [options]="processStepOptions" [(ngModel)]="selectedProcessStep" [filter]="true"
                        [style]="{'width':'230px'}" optionLabel="label" placeholder="Select a process step"
                        [showClear]="true"></p-dropdown>
                </div>
                 
                <div *ngIf="col.field == isBuffer">
                    <p-dropdown [options]="bufferChemicalOptions" optionLabel="name"
                        [(ngModel)]="selectedBufferChemical" [filter]="true" [style]="{'width':'230px'}"
                        placeholder="Select a Buffer" [showClear]="true"></p-dropdown>
                </div>
                <div *ngIf="col.field == isAssayType">
                    <p-dropdown [options]="assayTypeOptions" [(ngModel)]="selectedAssayType" optionLabel="label"
                        [filter]="true" [style]="{'width':'230px'}" placeholder="Select an AssayType"
                        [showClear]="true"></p-dropdown>
                </div>

                <div *ngIf="col.field == isJobTime" class="ui-dialog-buttonpane ui-helper-clearfix">
                    <button style="height: 35px; margin: 1%;" type="button" pButton icon="pi pi-check" (click)="runJobForProduct()"
                        label="Create Order"></button>
                </div>

                <div *ngIf="col.field==isHostAddress">
                    <input pInputText class="form-control" [(ngModel)]="masterList[col.field]"
                        (keyup)="ipNameEnforce($event)" (focus)="ipNameEnforce($event)">
                    <div [(hidden)]="isNotIpAddress" style="color:red">{{warningText}}</div>
                </div>
                 
                <div *ngIf="col.field == isDefaultTemplate">
                    <p-dropdown [options]="labelTemplateOptions" [(ngModel)]="selectedTemplate" [filter]="true"
                        [style]="{'width':'230px'}" optionLabel="templateName" placeholder="Select a Template"
                        [showClear]="true"></p-dropdown>
                </div>
                 
                <div *ngIf="col.field == isMaxRedo">
                    <p-dropdown [options]="maxRedoValues" [(ngModel)]="selectedMaxRedo" [filter]="true"
                        [style]="{'width':'230px'}" [showClear]="true"></p-dropdown>
                </div>
                 
                <div *ngIf="col.field == isProductMaxRedo">
                    <p-dropdown [options]="productMaxRedoValues" [(ngModel)]="selectedProductMaxRedo" [filter]="true"
                        [style]="{'width':'230px'}" [showClear]="true"></p-dropdown>
                </div>
                 
                <div *ngIf="col.field == isReactionOptionProtocol">
                    <p-dropdown [options]="reactionOptionValues" [(ngModel)]="reactionOption"
                        [style]=" {'width':'230px'}" [showClear]="true"></p-dropdown>
                </div>
                 
                <div *ngIf="col.field == 'subType'">
                    <input pInputText class="form-control" [ngClass]=" { 'disableTextBox' : isLabValid(col.field) }"
                        [(ngModel)]="masterList[col.field]" (change)="setSubType()">
                </div>
                 
                <div *ngIf="col.field == isFileType">
                    <p-dropdown [options]="machineFileTypeOptions" [(ngModel)]="selectedMachineFileType"
                        placeholder="Select a File Type" [style]="{'width':'230px'}" [showClear]="true">
                    </p-dropdown>
                </div>
                 
                <div *ngIf="col.field == isIOCapacity">
                    <p-dropdown [options]="ioCapacityOptions" [(ngModel)]="ioCapacity"
                        placeholder="Select a IO Capacity" [style]="{'width':'230px'}" [showClear]="true">
                    </p-dropdown>
                </div>
                 
                <div *ngIf="col.field == isManufacturer">
                    <p-dropdown [options]="machineManufacturerOptions" [(ngModel)]="selectedMachineManufacturer"
                        placeholder="Select a Manufacturer" [style]="{'width':'230px'}" [showClear]="true"
                        optionLabel="manufacturerName">
                    </p-dropdown>
                </div>
                 
            </div>
        </div>
         
        <div *ngIf="masterListType==8">
            <button pButton id="set-runtime-open" class="buttonsRound form-group runTimeButton" label="Set Runtime"
                (click)="openRuntimePopup()"></button>
            <p-table class="form-group" [value]="masterList.stepRuntimes">
                <ng-template pTemplate="header">
                    <tr>
                        <th scope="col">Workflow</th>
                        <th scope="col">Process Step</th>
                        <th scope="col">Processing Time</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData>
                    <tr>
                        <td>{{rowData.workflow}}</td>
                        <td>{{rowData.stepDisplayName}}</td>
                        <td>{{rowData.runtime}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
    <p-footer>
        <div class="ui-dialog-buttonpane ui-helper-clearfix">
            <button Style="height: 35px;" type="button" pButton icon="pi pi-check" [disabled]="isSaveDisabled()" (click)="saveMasterList()"
                label="Save"></button>
        </div>
    </p-footer>
</p-dialog>

<p-dialog header="Delete" [(visible)]="displayDeleteDialog" modal="modal" [style]="{width:'350px'}"
    [minY]="70" baseZIndex="15">
    <strong>Do you really want to delete this Item?</strong>
    <p-footer>
        <button type="button" pButton icon="pi pi-check" label="Yes" (click)="deleteMasterList()"></button>
        <button type="button" pButton icon="pi pi-times" (click)="displayDeleteDialog=false" label="No"></button>
    </p-footer>
</p-dialog>

<p-dialog  header="Set Runtime" [(visible)]="setRuntimePopup" modal="modal" [style]="{width:'400px'}" baseZIndex="15">
    <div>
        <div>
            <label>Workflow</label>
        </div>
        <div class="form-group">
            <p-dropdown [style]="{'width':'12rem'}" placeholder="Workflow" [options]="workFlowList" (onChange)="onChangeWorkflow()"
                name="workFlowList" [(ngModel)]="selectedMachineTypeWorkflow" >
            </p-dropdown>
        </div>
        <div>
            <label>Processing Time</label>
        </div>
        <p-table class="form-group" [value]="selectedMachineTypeStepRuntimes">
            <ng-template pTemplate="header">
                <tr>
                    <th scope="col">Process Step</th>
                    <th scope="col">Processing Time</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
                <tr>
                    <td> {{rowData.stepDisplayName}} </td>
                    <td>
                        <p-spinner name="step-rutime" size="3" [(ngModel)]="rowData.runtime" [min]="1"  [step]="1" placeholder="1"></p-spinner>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <p-footer>
        <button type="button" pButton icon="pi pi-check" label="Done" (click)="setRuntimes()"></button>
    </p-footer>
</p-dialog>